var map = {
	"./black/repository-black-da.json": 90,
	"./black/repository-black-de.json": 91,
	"./black/repository-black-ee.json": 92,
	"./black/repository-black-en.json": 93,
	"./black/repository-black-no.json": 94,
	"./black/repository-black-se.json": 95,
	"./black/template-setups-black.json": 26,
	"./grey/repository-grey-da.json": 96,
	"./grey/repository-grey-de.json": 97,
	"./grey/repository-grey-ee.json": 98,
	"./grey/repository-grey-en.json": 19,
	"./grey/repository-grey-no.json": 99,
	"./grey/repository-grey-se.json": 100,
	"./grey/template-setups-grey.json": 25,
	"./hd/repository-hd-da.json": 101,
	"./hd/repository-hd-de.json": 102,
	"./hd/repository-hd-ee.json": 103,
	"./hd/repository-hd-en.json": 104,
	"./hd/repository-hd-no.json": 105,
	"./hd/repository-hd-se.json": 106,
	"./hd/template-setups-hd.json": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;